<div fxLayout="row" fxLayoutAlign="center center">
  <div fxLayout="row" fxFlex="100%" fxFlex.sm="80%" fxFlex.md="80%" fxFlex.xs="100%" fxLayoutAlign="center stretch"
    fxLayoutGap="20px">
    <mat-card fxLayout="row wrap" fxFlex="1000px" fxFlex.xs="100%" fxLayoutAlign="center stretch"
      class="mat-elevation-z-sides">
      <img mat-card-image name="header-course-img" class="header-img" src="{{(course$ | async )?.iconPath}}" alt="{{(course$ | async)?.name}}">
      <mat-card-content fxFlex.xs="90%" fxFlex="70%" fxLayout="column" fxLayoutAlign="space-around stretch"
        fxLayoutGap="20px">
        <br />
        <h1 name="course-header"><b>{{(course$ | async)?.name | translateDynamic}}</b></h1>

        <div class="initial-assessment-welcome">
          <h3 i18n="@@ia-user-header" name="user-header">Welcome, {{userFirstName + ' ' + userLastName}}.</h3>
          <br />

          <p i18n="@@ia-welcome-1" name="ia-welcome-1">
            Before you start your learning, you need to complete
            an initial assessment in {{(course$ | async)?.name}}.
          </p>
          <p i18n="@@ia-welcome-2" name="ia-welcome-1">
            The results will help us to find out what you can do
            already and where you can improve.
          </p>
        </div>

        <mat-accordion fxLayout="column" fxLayoutGap="0px" multi>
          <mat-progress-bar *ngIf="(courseLoader$ | async) || (reAssignLoader$ | async) || (generatePlanLoader$ | async) || isCheckingLearningPlan" mode="indeterminate"></mat-progress-bar>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title i18n="@@assign-target-information" name="assign-target-information">
                <b>Information</b>
              </mat-panel-title>

            </mat-expansion-panel-header>
            <div class="initial-assessment-practice-desc">
              <p i18n="@@assign-target-desc-1" name="assign-target-desc-1">
                It seems your initial assessment result is not completed.
              </p>
              <p i18n="@@assign-target-desc-2" name="assign-target-desc-2">
                Click 'View Initial Assessment' button to check your progress.
              </p>
            </div>
            <div fxLayout="column" fxLayoutAlign="space-between center">
              <button i18n="@@button-launch-practice-assessment" mat-raised-button color="primary"
                [disabled]="(reAssignLoader$ | async) || (generatePlanLoader$ | async) || isCheckingLearningPlan"
                name="button-launch-practice-assessment" id="btnLaunchPracticeAssessment"
                (click)="onViewInitialAssessment()">View Initial Assessment
              </button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <app-browser-note></app-browser-note>
      </mat-card-content>
    </mat-card>
  </div>
</div>